import React, { Component,Fragment } from "react";
import "./Site.css";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
  Input,
  Alert as Alert2,
  ButtonGroup,
  InputGroupText,
  InputGroup,
  InputGroupAddon,
  Collapse
} from "reactstrap";
import moment from "moment";
import Alert from "react-s-alert";
import _ from "lodash";
import './Site.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MaintenanceDetails, EquipmentDamages, EquipmentDocument } from "../components";
import { api, stringHelper,constant } from "../helpers";
import ToggleButton from 'react-toggle-button';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { Link, Redirect } from "react-router-dom";

const getEquipmentTypes = () => api.fetch('Reference/EquipmentTypes').then(response => {
  return {
    equipmentTypeList: _.map(response.data, x => { return { value: x.id, label: x.name }; })
  };
}).catch(x => console.error(x));
const getEquipmentStatuses = () => api.fetch('Reference/EquipmentStatus').then(response => {
  return {
    equipmentStatusList: _.map(response.data, x => { return { value: x.id, label: x.name }; })
  };
}).catch(x => console.error(x));
const getCalibrationTypes = () => api.fetch('Reference/CalibrationTypes').then(response => {
  return {
    calibrationTypeList: _.map(response.data, x => { return { value: x.id, label: x.name }; })
  };
}).catch(x => console.error(x));
const getCalibrationFrequencies = () => api.fetch('Reference/CalibrationFrequencies').then(response => {
  return {
    calibrationFrequencyList: _.map(response.data, x => { return { value: x.id, label: x.name }; })
  };
}).catch(x => console.error(x));
const getVendors = () => api.fetch('Reference/Vendors').then(response => {
  return {
    vendorList: _.map(response.data, x => { return { value: x.id, label: x.name }; })
  };
}).catch(x => console.error(x));
const getTestingMethods = () => api.fetch('Reference/TestingMethods').then(response => {
  return {
    testingMethodList: _.map(response.data, x => { return { value: x.id, label: x.name }; })
  };
}).catch(x => console.error(x));
const getLocations = () => api.fetch('Reference/Locations').then(response => {
  return {
    locationsList: _.map(response.data, x => { return { value: x.id, label: x.name }; })
  };
}).catch(x => console.error(x));

const emptyEquipment =() => {
  return {
    id: -1,
    name: '',
    referenceCode: '',
    serialNumber: '',
    modelNumber: '',
    description: '',
    typeOfEquipment: null,
    dateReceived: null,
    isDateReceivedEstimated: false,
    dateActivated: null,
    isDateActivatedEstimated: false,
    equipmentStatus: null,
    location: null,
    testingMethod: null,
    requiresCalibration: false,
    hasProductContact: false,
    vendor: null,
    calibrationFrequency: null,
    calibrationFrequencyAmount: '',
    calibrationType: null,
    calibrationDescription: '',
    beginningCalibrationRange: '',
    endingCalibrationRange: '',
    notes: ''
  };
}

export default class EditEquipment extends Component {
  static displayName = EditEquipment.name;
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false,
      loading: true,
      equipmentId: props.match && props.match.params && props.match.params.id
        ? props.match.params.id
        : null,
      editEquipment: null,
      equipmentTypeList: [],
      equipmentStatusList: [],
      locationsList: [],
      calibrationTypeList: [],
      calibrationFrequencyList: [],
      vendorList: [],
      vendorMechanicList: [],
      testingMethodList: [],
      redirect: false,
      detailsCollapse: false,
      viewOnly:
        this.props.location.state && this.props.location.state.viewOnly
          ? this.props.location.state.viewOnly
          : false,
    };

    this.loadEquipment = this.loadEquipment.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.isFormValid = this.isFormValid.bind(this);
    this.getVendorMechanics = this.getVendorMechanics.bind(this);
    this.toggleCollapse = this.toggleCollapse.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.deleteScheduledWork = this.deleteScheduledWork.bind(this);
  }

  componentDidMount() {
    Promise.all([getEquipmentTypes(), getEquipmentStatuses(), getCalibrationTypes(), getCalibrationFrequencies(),
    getVendors(), getTestingMethods(), getLocations()]).then(response => {
      let newStatus = {};
      _.each(response, r => Object.assign(newStatus, r));
      this.setState(newStatus, () => { this.loadEquipment();});
    });
  }

  loadEquipment() {
    if (this.props.match && this.props.match.params && this.props.match.params.id === "new") {
      this.setState({ editEquipment: emptyEquipment(), loading: false, detailsCollapse: true });
    } else {
        api.post("Equipment/GetEquipment", this.state.equipmentId)
          .then(response => {
            if (response.data) {
              var equipment = response.data;
              equipment.equipmentStatus = equipment.equipmentStatusId
                ? stringHelper.resolveValueFromList(this.state.equipmentStatusList, equipment.equipmentStatusId)
                : null;
              equipment.equipmentType = equipment.equipmentTypeId
                ? stringHelper.resolveValueFromList(this.state.equipmentTypeList, equipment.equipmentTypeId)
                : null;
              equipment.location = equipment.locationId
                ? stringHelper.resolveValueFromList(this.state.locationsList, equipment.locationId)
                : null;
              equipment.testingMethod = equipment.testingMethodId
                ? stringHelper.resolveValueFromList(this.state.testingMethodList, equipment.testingMethodId)
                : null;
              equipment.vendor = equipment.vendorId
                ? stringHelper.resolveValueFromList(this.state.vendorList, equipment.vendorId)
                : null;
              equipment.calibrationFrequency = equipment.calibrationFrequencyId
                ? stringHelper.resolveValueFromList(this.state.calibrationFrequencyList, equipment.calibrationFrequencyId)
                : null;
              equipment.calibrationType = equipment.calibrationTypeId
                ? stringHelper.resolveValueFromList(this.state.calibrationTypeList, equipment.calibrationTypeId)
                : null;
              equipment.dateReceived = equipment.dateReceived ? moment(equipment.dateReceived).toDate() : null;
              equipment.dateActivated = equipment.dateActivated ? moment(equipment.dateActivated).toDate() : null;
              equipment.nextScheduledMaintenanceDate = null;
              equipment.nextScheduledCalibrationDate = null;
              this.setState({
                editEquipment: equipment,
                loading: false,
              });
            }
          })
      }
  }

  onDismiss() {
    this.setState({
      isMessageVisible: !this.state.isMessageVisible,
      message: null,
      messageColor: null,
    });
  }

  getVendorMechanics(vendorId) {
    api.fetch('Equipment/VendorMechanics', {VendorId: vendorId})
      .then(response => {
        if (response.data) {
          return {
            vendorMechanicList: response.data
          };
        }
    }).catch(x => console.error(x));
  }

  onInputChange(e, fieldName) {
    this.setState({
      editEquipment: { ...this.state.editEquipment, [fieldName]: e.target.value }
    })
  }

  onDateChange(date, fieldName, maintenanceTypeId) {
    this.setState({
      editEquipment: { ...this.state.editEquipment, [fieldName]: date }
    }, () => {
        if (maintenanceTypeId !== undefined) {
          const payload = {
            EquipmentId: this.state.editEquipment.id,
            MaintenanceTypeId: maintenanceTypeId,
            Date: date
          }
          api.post("Equipment/SaveScheduleDate", payload)
            .then(response => {
              if (response.data.success) {
                Alert.success("Maintenance date has been saved.");
                this.loadEquipment();
              } else {
                Alert.success("Maintenance date cannot be saved at this time.");
              }
            }).catch(x => {
              Alert.error("An unexpected error occured.")
              console.error(x)
            });
        }
      }
    )
  }

  onSelectChange(selection, fieldName) {
    let equipment = Object.assign({}, this.state.editEquipment);
    equipment[fieldName] = selection;
    if (selection.label === 'Manual') {
      equipment.calibrationFrequencyAmount = '';
    }
    if (selection.label === 'Range') {
      equipment.beginningCalibrationRange = '';
      equipment.endingCalibrationRange = '';
    }
    this.setState({
      editEquipment: equipment
    });
  }

  onToggleButtonChange(value, fieldName) {
    this.setState({
      editEquipment: {
        ...this.state.editEquipment,
        [fieldName]: !this.state.editEquipment[fieldName]
      }
    });
  }

  onEdit() {
    this.setState({ viewOnly: false })
  }

  onCancel() {
    this.setState({
      editEquipment: null
    });
  }

  toggleCollapse() {
    this.setState({
      detailsCollapse: !this.state.detailsCollapse
    })
  }

  isFormValid() {
    let warnings = [];
    if (this.state.editEquipment.name === '') {
      warnings.push("Please enter name");
    }
    if (this.state.editEquipment.referenceCode === '') {
      warnings.push("Please enter reference code");
    }
    if (this.state.editEquipment.serialNumber === '') {
      warnings.push("Please enter serialNumber");
    }
    if (!this.state.editEquipment.equipmentType) {
      warnings.push("Please enter an equipment type");
    }

    if (!this.state.editEquipment.equipmentStatus) {
      warnings.push("Please enter a equipment status");
    }
    if (!this.state.editEquipment.location) {
      warnings.push("Please enter a location");
    }

    this.setState({ message: (warnings.length ? warnings.join(", ") : null), messageColor: "danger", isMessageVisible: true });
    return warnings.length === 0;
  }

  onSave() {
    if (!this.isFormValid()) return;
    const equipment = Object.assign({}, this.state.editEquipment);
    let payload = {
      Id: equipment.id,
      Name: equipment.name,
      Description: equipment.description,
      ReferenceCode: equipment.referenceCode,
      SerialNumber: equipment.serialNumber,
      ModelNumber: equipment.modelNumber,
      DateReceived: equipment.dateReceived,
      IsDateReceivedEstimated: equipment.isDateReceivedEstimated,
      DateActivated: equipment.dateActivated,
      IsDateActivatedEstimated: equipment.isDateActivatedEstimated,
      EquipmentStatusId: equipment.equipmentStatus ? parseInt(equipment.equipmentStatus.value, 10) : null,
      LocationId: equipment.location ? parseInt(equipment.location.value, 10) : null,
      TestingMethodId: equipment.testingMethod ? parseInt(equipment.testingMethod.value, 10) : null,
      EquipmentTypeId: equipment.equipmentType ? parseInt(equipment.equipmentType.value, 10) : null,
      VendorId: equipment.vendor ? parseInt(equipment.vendor.value, 10) : null,
      CalibrationTypeId: equipment.calibrationType ? parseInt(equipment.calibrationType.value, 10) : null,
      CalibrationFrequencyId: equipment.calibrationFrequency ? parseInt(equipment.calibrationFrequency.value, 10) : null,
      CalibrationDescription: equipment.calibrationDescription,
      CalibrationFrequencyAmount: equipment.calibrationFrequencyAmount !== "" ? parseInt(equipment.calibrationFrequencyAmount, 10) : null,
      BeginningCalibrationRange: equipment.beginningCalibrationRange !== "" ? parseFloat(equipment.beginningCalibrationRange) : null,
      EndingCalibrationRange: equipment.endingCalibrationRange !== "" ? parseFloat(equipment.endingCalibrationRange) : null,
      Notes: equipment.notes,
      HasProductContact: equipment.hasProductContact,
      RequiresCalibration: equipment.requiresCalibration,
    }
    api.post("Equipment/SaveEquipment", payload)
      .then(response => {
        if (response.data.success) {
          Alert.success("Equipment details was saved. You will be redirected momentarily");
          this.timer = setTimeout(() => {
            this.setState({ redirect: true });
          }, 3000);

          this.loadEquipment();
        } else {
          if (response.data.message) {
            Alert.error(response.data.message)
          } else {
            Alert.error("An error occured saving equipment details.")
          }
        }
      }).catch(x => {
        Alert.error("An unexpected error occured.")
        console.error(x)
      });
  }

  deleteScheduledWork(scheduledWorkId, maintenanceTypeNameLowercase) {
    if (!window.confirm(`Are you sure you'd like to the Scheduled ${maintenanceTypeNameLowercase} for this equipment?`)) return;

    api.delete(`Equipment/DeleteScheduledWork/${scheduledWorkId}`)
      .then(response => {
        if (response.data.success) {
          Alert.success(`Scheduled ${maintenanceTypeNameLowercase} was deleted for this equipment.`)
          this.loadEquipment();
        } else {
          Alert.error(`An error occurred. Scheduled ${maintenanceTypeNameLowercase} cannot be deleted at this time.`)
        }
      }).catch(error => {
        Alert.error(`There was an error deleting the scheduled ${maintenanceTypeNameLowercase} for this equipment.`)
      });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={`/admin`} />;
    }

    const {
      message,
      messageColor,
      editEquipment,
      viewOnly
    } = this.state;
    return (
      <div className="ml-4 mr-4">
        {editEquipment && 
          <React.Fragment>
            <Row className="mb-2">
            <Col><h5>{editEquipment.id < 0 ? "New Equipment" : `${editEquipment.name}`} {editEquipment.deactivatedAt && <span className="cbdmdDangerText boldText">(Deleted)</span>}</h5></Col>
              <Col>
                <ButtonGroup className="float-right">
                {viewOnly ? (
                  <Button size="sm" className="cbdmdSecondary buttonGroupSpacing"
                    title="Back"
                    tag={Link}
                    to={{ pathname: "/equipment", push: true }}
                  >
                    <FontAwesomeIcon icon="reply" /> Back
                  </Button>

                ) : (
                <Fragment>
                  <Button size="sm" className="cbdmdSecondary buttonGroupSpacing" onClick={() => this.onCancel()} tag={Link}
                    to={{
                      pathname: "/admin" ,
                      state: { tabName: "equipment" },
                      push: true,
                    }}
                  >
                    <FontAwesomeIcon icon="reply" /> Back
                  </Button>
                  <Button size="sm" className="cbdmdPrimary buttonGroupSpacing" onClick={() => this.onSave()}>
                    <FontAwesomeIcon icon="save" title={editEquipment.id > 0 ? "Update" : "Save"} /> Save
                      </Button>
                  </Fragment>
                )}
                </ButtonGroup>
              </Col>
            </Row>

            {this.state.message ? (
              <Alert2 color={messageColor} toggle={() => this.onDismiss()}>{message}</Alert2>
            ) : null}

            <Card className="p-2 mb-2">
            <CardHeader className="boldText">
              <span className="mr-2"><FontAwesomeIcon icon="book-open" /></span>
              Details
              {editEquipment.id > 0 &&
                <Button size="sm" className="float-right cbdmdSuccess" onClick={() => this.toggleCollapse()}>{this.state.detailsCollapse ? "View Less" : "View More"}</Button>
              }
            </CardHeader>
            <Collapse isOpen={this.state.detailsCollapse}>
                <CardBody>
                  <Row>
                    <Col className="p-2"title="Details">
                      <Row className="mb-2">
                    <Col>Name: <Input type="text" name="name" id="name" onChange={(e) => this.onInputChange(e, "name")} value={editEquipment.name} disabled={this.state.viewOnly}/></Col>
                      <Col>Equipment Status:
                         <Select
                        closeMenuOnSelect={true}
                        value={editEquipment.equipmentStatus}
                        options={this.state.equipmentStatusList}
                        onChange={(e) => this.onSelectChange(e, "equipmentStatus")}
                        isDisabled={this.state.viewOnly}
                        />
                      </Col>
                      </Row>

                      <Row className="mb-2">
                        <Col>Reference Code:
                          <Input
                          type="text"
                          name="referenceCode"
                          id="referenceCode"
                          maxLength="60"
                          onChange={(e) => this.onInputChange(e, "referenceCode")}
                          value={editEquipment.referenceCode}
                          disabled={this.state.viewOnly} />
                        </Col>
                        <Col>Serial Number:
                          <Input
                          type="text"
                          name="serialNumber"
                          maxLength="60"
                          id="serialNumber"
                          onChange={(e) => this.onInputChange(e, "serialNumber")} value={editEquipment.serialNumber} disabled={this.state.viewOnly} />
                        </Col>
                        <Col>Model Number:
                          <Input
                          type="text"
                          maxLength="60"
                          name="modelNumber"
                          id="modelNumber"
                          onChange={(e) => this.onInputChange(e, "modelNumber")} value={editEquipment.modelNumber} disabled={this.state.viewOnly} />
                        </Col>
                      </Row>

                      <Row className="mb-2">
                        <Col>Location:
                          <Select
                            closeMenuOnSelect={true}
                            value={editEquipment.location}
                            options={this.state.locationsList}
                            onChange={(e) => this.onSelectChange(e, "location")}
                            isDisabled={this.state.viewOnly}
                          />
                        </Col>
                        <Col>Vendor:
                          <Select
                            closeMenuOnSelect={true}
                            value={editEquipment.vendor}
                            options={this.state.vendorList}
                            isDisabled={this.state.viewOnly}
                            onChange={(e) => this.onSelectChange(e, "vendor")}
                          />
                        </Col>
                        <Col>Testing Method:
                          <Select
                            closeMenuOnSelect={true}
                            value={editEquipment.testingMethod}
                            options={this.state.testingMethodList}
                            onChange={(e) => this.onSelectChange(e, "testingMethod")}
                            isDisabled={this.state.viewOnly}
                          />
                        </Col>
                      </Row>

                      <Row className="mb-2">
                        <Col>Equipment Type:
                          <Select
                            closeMenuOnSelect={true}
                            value={editEquipment.equipmentType}
                            options={this.state.equipmentTypeList}
                            onChange={(e) => this.onSelectChange(e, "equipmentType")}
                            isDisabled={this.state.viewOnly}
                          />
                        </Col>

                        <Col>
                          <span>
                            Has Product Contact?
                             <ToggleButton
                              value={editEquipment.hasProductContact}
                              activeLabel={"Yes"}
                              inactiveLabel={"No"}
                              isDisabled={this.state.viewOnly}
                              onToggle={(value) => {
                                this.onToggleButtonChange(value, "hasProductContact")
                              }}
                            />
                          </span>

                        </Col>
                        <Col>
                          <span>
                            Requires Calibration
                                <ToggleButton
                              value={editEquipment.requiresCalibration}
                              activeLabel={"Yes"}
                              inactiveLabel={"No"}
                              isDisabled={this.state.viewOnly}
                              onToggle={(value) => {
                                this.onToggleButtonChange(value, "requiresCalibration")
                              }}
                            />
                          </span>

                        </Col>
                  </Row>

                      {editEquipment.requiresCalibration &&
                        <React.Fragment>
                          <Row className="mb-2">
                          <Col>Calibration Type:
                            <Select
                              closeMenuOnSelect={true}
                              value={editEquipment.calibrationType}
                              options={this.state.calibrationTypeList}
                              onChange={(e) => this.onSelectChange(e, "calibrationType")}
                              isDisabled={this.state.viewOnly}
                            />
                            </Col>
                        {/*<Col>Calibration Frequency Amount:
                              <Input
                                type="number"
                                name="calibrationFrequencyAmount"
                                id="calibrationFrequencyAmount"
                                onChange={(e) => this.onInputChange(e, "calibrationFrequencyAmount")}
                                disabled={this.state.viewOnly}
                                value={editEquipment.calibrationFrequencyAmount} />
                            </Col>*/}
                            <Col>Calibration Frequency:
                               <Select
                                closeMenuOnSelect={true}
                                value={editEquipment.calibrationFrequency}
                                options={this.state.calibrationFrequencyList}
                                disabled={this.state.viewOnly}
                                onChange={(e) => this.onSelectChange(e, "calibrationFrequency")}
                              />
                            </Col>
                          </Row>
                          {editEquipment.calibrationType && editEquipment.calibrationType.label === "Range" &&
                            <Row className="mb-2">
                              <Col>Beginning Calibration Range:
                                <InputGroup>
                                  <Input
                                    type="number"
                                    step="0.01"
                                    name="beginningCalibrationRange"
                                    id="beginningCalibrationRange"
                                    placeholder="0.00"
                                    onChange={(e) => this.onInputChange(e, "beginningCalibrationRange")}
                                    value={editEquipment.beginningCalibrationRange}
                                    disabled={this.state.viewOnly}
                                  />
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText>+/-</InputGroupText>
                                  </InputGroupAddon>
                                </InputGroup>
                              </Col>
                              <Col>Ending Calibration Range:
                                <InputGroup>
                                    <Input
                                      type="number"
                                      step="0.01"
                                      name="endingCalibrationRange"
                                      id="endingCalibrationRange"
                                      placeholder="0.00"
                                      onChange={(e) => this.onInputChange(e, "endingCalibrationRange")}
                                      disabled={this.state.viewOnly}
                                      value={editEquipment.endingCalibrationRange} />
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText>+/-</InputGroupText>
                                  </InputGroupAddon>
                                </InputGroup>
                              </Col>
                            </Row>
                          }
                          <Row className="mb-2">
                            <Col>Calibration Description
                              <Input
                                type="textarea"
                                name="calbirationDescription"
                                maxLength="255"
                                id="calibrationDescription"
                                value={editEquipment.calibrationDescription}
                                onChange={(e) => this.onInputChange(e, "calibrationDescription")}
                                disabled={this.state.viewOnly}
                              />
                            </Col>
                          </Row>
                        </React.Fragment>
                      }
                    </Col>
                {/*===================================== TEXT AREA SECTION=========================================*/}
                    <Col className="p-2 ml-2" >
                      <Row className="mb-2">
                        <Col>Date Received
                              <DatePicker
                            selected={editEquipment.dateReceived}
                            className="form-control pageTitleItem float-right"
                            placeholderText="Select a date received"
                            onChange={(e) => this.onDateChange(e, "dateReceived")}
                            disabled={this.state.viewOnly}
                          />
                        </Col>
                        <Col>
                          <span>
                            Estimated?
                                <ToggleButton
                              value={editEquipment.isDateReceivedEstimated}
                              activeLabel={"Yes"}
                          inactiveLabel={"No"}
                          disabled={this.state.viewOnly}
                              onToggle={(value) => {
                                this.onToggleButtonChange(value, "isDateReceivedEstimated")
                              }}
                            />
                          </span>
                        </Col>
                        <Col>Date Activated
                              <DatePicker
                            selected={editEquipment.dateActivated}
                            className="form-control pageTitleItem float-right"
                        placeholderText="Select a date"
                        disabled={this.state.viewOnly}
                            onChange={(e) => this.onDateChange(e, "dateActivated")}
                          />
                        </Col>
                        <Col>
                          <span>
                            Estimated?
                            <ToggleButton
                              value={editEquipment.isDateActivatedEstimated}
                              activeLabel={"Yes"}
                              inactiveLabel={"No"}
                              disabled={this.state.viewOnly}
                              onToggle={(value) => {
                                this.onToggleButtonChange(value, "isDateActivatedEstimated")
                              }}
                            />
                          </span>
                        </Col>
                      </Row>

                      <Row className="">
                        <Col>Description:
                          <Input
                          type="textarea"
                          maxLength="255"
                          name="description"
                          id="description"
                          onChange={(e) => this.onInputChange(e, 'description')}
                          value={editEquipment.description} disabled={this.state.viewOnly} />
                        </Col>
                      </Row>
                      <Row>
                        <Col>Notes:
                          <Input
                          type="textarea"
                          maxLength="500"
                          name="notes"
                          id="notes"
                          onChange={(e) => this.onInputChange(e, 'notes')}
                          value={editEquipment.notes} disabled={this.state.viewOnly} />
                        </Col>
                    </Row>
                    </Col>
                </Row>
              </CardBody>
              </Collapse>
          </Card>
          {editEquipment.id > 0 &&
            <Fragment>
              <EquipmentDocument
                equipmentId={editEquipment.id}
                viewOnly={viewOnly}
              />
              <EquipmentDamages
                equipmentId={editEquipment.id}
                reLoad={this.loadEquipment}
                damageList={editEquipment.equipmentDamageRecords}
              />
            </Fragment>
          }
          {editEquipment.maintenanceRecords &&
              <MaintenanceDetails
                title={constant.maintenanceType.Maintenance.name}
                equipmentId={editEquipment.id}
                maintenanceRecords={editEquipment.maintenanceRecords}
                nextScheduledMaintenance={editEquipment.scheduledMaintenance}
                deleteScheduledWork={this.deleteScheduledWork}
                nextScheduledDate={editEquipment.nextScheduledMaintenanceDate}
                onDateChange={this.onDateChange}
                maintenanceTypeId={constant.maintenanceType.Maintenance.id}
              />
          }
          {editEquipment.requiresCalibration && editEquipment.calibrationRecords &&
            <MaintenanceDetails
              title={constant.maintenanceType.Calibration.name}
              equipmentId={editEquipment.id}
              maintenanceRecords={editEquipment.calibrationRecords}
              nextScheduledMaintenance={editEquipment.scheduledCalibration}
              deleteScheduledWork={this.deleteScheduledWork}
              onDateChange={this.onDateChange}
              nextScheduledDate={editEquipment.nextScheduledCalibrationDate}
              maintenanceTypeId={constant.maintenanceType.Calibration.id}
            />
          }
          </React.Fragment>
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/EditEquipment.js